export const TextEditors = {
  MathJax: 'MATHJAX',
  RichEditor: 'RICHEDITOR',
};

export class Option {
  optionText = '';
  optionImgUrl = '';
  isCorrect = false;
  textEditor = TextEditors.MathJax;
}

export const Variants = ['A', 'B', 'C', 'D', 'E'];
